import { useRef } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ContactForm from '../sections/contact-form';

function Contact() {
    const contactRef = useRef<HTMLDivElement>(null);

    return (
        <Row className="contact section--background section--contact" ref={contactRef}>
            <Col
                md={{ offset: 1, span: 7 }}
                className="contact__heading-col"
            >
                <h1 className="contact__heading-col__heading">
                    Lets Build Something Amazing Together<br />
                </h1>
            </Col>
            <Col md={4} className="contact__form-col">
                <ContactForm />
            </Col>
        </Row>
    );
}

export default Contact;

